import { NgModule } from '@angular/core';

import { SanitizeBypassPipe } from './sanitize-bypass.pipe';

@NgModule({
	exports: [SanitizeBypassPipe],
	declarations: [SanitizeBypassPipe],
	providers: [SanitizeBypassPipe]
})
export class SanitizeBypassModule {}
